import { AbstractControl } from '@angular/forms';

export function min(
    minVal: any
  ): {
    [key: string]: any;
  } {
    return (
      control: AbstractControl
    ): {
      [key: string]: any;
    } => {
      const v: any = control.value;
      return v >= minVal
        ? null
        : {
            min: true
          };
    };
  }
export function max(
  maxVal: any
): {
  [key: string]: any;
} {
  return (
    control: AbstractControl
  ): {
    [key: string]: any;
  } => {
    const v: any = control.value;
    return v <= maxVal
      ? null
      : {
          max: true
        };
  };
}
